export const BLOG_POSTS = [
  {
    title:
      "Musings from the AI and Games Conference 2025",
    slug: "/blog/ai-and-games-conf-2025",
    date: "Dec 2025",
    author: "Team Atelico",
    publishDate: "December 4, 2025",
    thumbnail: "/announce/ai-games_recap01.jpg",
  },
  {
    title:
      "gamescom & devcom 2025: Moving beyond AI buzzwords and back into making great games!",
    slug: "/blog/gamescom-2025-recap",
    date: "Sep 2025",
    author: "Ennio",
    publishDate: "September 20, 2025",
    thumbnail: "/announce/ennio_devcom2025.jpg",
  },
  {
    title: "Studio Atelico Raises $5M to Build Games That Couldn’t Exist Before",
    slug: "/blog/funding-announcement",
    date: "Aug 2025",
    author: "Studio Atelico",
    publishDate: "August 14, 2025",
    thumbnail: "/announce/fundraising_announcement_blog.png",
  },
  {
    title: "Cloud AI for video games is dead on arrival",
    slug: "/blog/cloud-ai-for-video-games-is-dead-on-arrival",
    date: "Jan 2025",
    author: "Piero Molino",
    publishDate: "January 8, 2025",
    thumbnail: "/announce/image1.gif",
  },
  {
    title: "How to use AI in video games without losing your soul",
    slug: "/blog/game-ai-art-without-losing-your-soul",
    date: "July 2025",
    author: "Piero Molino and Paul Szerlip",
    publishDate: "July 8, 2025",
    thumbnail: "/how_to_use_ai/figure_schema.png",
  },
];

export const CAREERS = [
  {
    title: "Art Director",
    slug: "/careers/art-director",
    date: "July 2025",
    author: "",
    publishDate: "",
    thumbnail: "/how_to_use_ai/on_device_versus_cloud.png",
    category: "hiring",
  },
];

export const ALL_POSTS = [...BLOG_POSTS, ...CAREERS];
